import { getDefaultANumbersState } from "./index";
import { MutationTree } from "vuex";
import { IANumbersState } from ".";
import { getDefaultSettings } from "http2";
import { IANumberAssignment } from "@/models/anumberassignments";
import { IANumber } from "@/models/anumber";
import { IANumberGroup } from "@/models/anumbergroup";

export const mutations: MutationTree<IANumbersState> = {
    setANumberAssignments(state, payload: IANumberAssignment[]) {
        state.aNumberAssignmentsError = null;
        state.aNumberAssignmentsList = [...payload];
    },
    setANumberGroups(state, payload: IANumberGroup[]) {
        state.aNumberGroupsError = null;
        state.aNumberGroupsList = [...payload];
    },
    setSelectedANumberAssignment(state, payload: IANumber) {
        state.selectedANumberAssignment = payload;
    },
    setSelectedANumberGroup(state, payload: IANumberGroup) {
        state.selectedANumberGroup = payload;
    },
    setANumberAssignmentError(state, payload: any) {
        state.aNumberAssignmentsError = payload;
    },
    setANumberGroupError(state, payload: any) {
        state.aNumberGroupsError = payload;
    },
    resetState(state) {
        Object.assign(state, getDefaultANumbersState());
    },
};
